import React from 'react';
import T from 'prop-types';

import Button from '../Button';

export const ScreenshotButton = ({
  href,
  target,
  disabled,
  onClick,
}) => (
  <Button
    variant="secondary"
    shape="square"
    href={href}
    target={target}
    disabled={disabled}
    onClick={onClick}
  >
    <i className="hicon-snapshot" />
  </Button>
);

ScreenshotButton.propTypes = {
  href: T.string,
  disabled: T.bool,
  target: T.string,
  onClick: T.func,
};
